<template>
  <div class="photo-list-container">
    <common-card :card-title="photoCardTitle">
      <template v-slot:right>
        <div class="manage-album">
          <el-button
            type="text"
            class="none-border"
            size="small"
            plain
            @click="showDeleteImgIcon"
          >{{ manageAlbumTitle }}</el-button>
          <el-button
            type="primary"
            class="none-border"
            size="small"
            plain
            @click="addPhoto"
          >新增</el-button>
        </div>
      </template>
      <div class="base-block">
        <div class="photo-container">
          <template v-for="item in albumData">
            <div :key="item.id" class="img-block">
              <span>
                <i
                  v-show="deleteIconShow"
                  style="color: red; z-index: 2000; cursor: pointer"
                  class="el-icon-delete del-img"
                  @click="handleDelete(item.id)"
                />
                <el-image
                  :lazy="true"
                  :style="imageStyle"
                  :src="baseUrl+item.url"
                  :z-index="1000"
                  :preview-src-list="previewList"
                  fit="scale-down"
                />
              </span>
            </div>
          </template>
        </div>
        <el-pagination
          :current-page="page.currentPage"
          :page-sizes="[14, 28, 42, 56]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </common-card>
    <!-- 修改虚拟用户配置对话框 -->
    <el-dialog :title="dialogPhoto.title" :visible.sync="dialogPhoto.visible" width="600px">
      <el-form ref="photoForm" :model="photoForm"  label-width="100px">
        <el-form-item label="相册">
          <single-upload-cos v-model="photoForm.urls" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handlePhotoSubmit">确 定</el-button>
        <el-button @click="dialogPhoto.visible=false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 相册信息
 * @author yang5chao@aliyun.com
 */
import CommonCard from '@/components/CommonCard'
import { getUserAlbum, deleteUserAlbum,saveUserPhoto } from '@/api/user'
import SingleUploadCos from "@/components/upload/single-upload-cos";
export default {
  name: 'PhotoList',
  components: {
    CommonCard,
    SingleUploadCos
  },
  data() {
    return {
      page: {
        pageSize: 14,
        currentPage: 1,
        tolal:0
      },
      baseUrl:$imgUrl,
      photoForm:{},
      dialogPhoto:{
        visible:false,
      },
      deleteIconShow: true,
      albumData: {},
      photoCardTitle: '相册列表',
      imageStyle:
        'width: 150px; height: 150px;margin-left:26px;margin-bottom:26px'
    }
  },
  computed: {
    previewList() {
      return this.albumData.map((item) => $imgUrl+item.url)
    },
    manageAlbumTitle() {
      return this.deleteIconShow ? '取消' : '管理相册'
    }
  },
  beforeMount() {
    this.onLoad(this.page)
  },

  methods: {
    handlePhotoSubmit(){
      this.photoForm.userId = this.$route.query.userId

      saveUserPhoto(this.photoForm).then(() => {
        this.$message.success('添加成功')
        this.dialogPhoto.visible = false
        this.onLoad()
      })
    },
    onLoad(page) {
      const {userId} = this.$route.query
      const {pageSize,currentPage} = this.page;
      getUserAlbum({page:currentPage,limit:pageSize,userId}).then((res) => {
        this.albumData = res.data
        this.page.total = res.total
      })
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage
      this.$nextTick(() => {
        this.onLoad(this.page)
      })
    },
    showDeleteImgIcon() {
      this.deleteIconShow = !this.deleteIconShow
    },
    addPhoto(){
      this.dialogPhoto.visible = true
    },
    handleDelete(id) {
      // 弹窗确认是否删除
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const { userId } = this.$route.query
          deleteUserAlbum({ userId, id }).then(() => {
            this.albumData = this.albumData.filter(item => item.id != id)
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.photo-list-container {
  margin-top: 1.2rem;
  .manage-album {
    margin-right: 30px;
    .none-border {
      color: red;
      border: 0;
      background-color: transparent !important;
    }
  }
  .base-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    .photo-container {
      margin-top: 18px;
      display: flex;
      align-content: flex-start;
      flex-wrap: wrap;
      .img-block {
        position: relative;
        .del-img {
          position: absolute;
          top: 0px;
          left: 150px;
        }
      }
    }
  }
}
</style>>

